import { render } from "./MarketingMailingAdditionalFormComponent.vue?vue&type=template&id=fdc7a65c"
import script from "./MarketingMailingAdditionalFormComponent.vue?vue&type=script&lang=js"
export * from "./MarketingMailingAdditionalFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__